import React from "react";
import SocietyLayout from "../SocietyLayout";
import "./dashboard.css";

const Dashboard = () => {
  return (
    <SocietyLayout>
      <h1 className="page-title">Dashboard Overview</h1>

      <a href="/dashboard/notes" className="note-card">
        <p className="note-tag">Notes</p>
        <h2>Add your Ideas!</h2>
        <p>Take notes of your ideas and thoughts</p>
      </a>
    </SocietyLayout>
  );
};

export default Dashboard;